module.exports = "/images/vendor/flag-icon-css/flags/1x1/mx.svg?3aa223c8cc48eba75fbb57fcc20ce7cc";